import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromRoomingPerDayDataStore from './state/rooming-per-day-data-store.reducer';

/* effects */
import { RoomingPerDayDataStoreEffects } from './state/rooming-per-day-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* RoomingPerDayDataStore State */
    StoreModule.forFeature(
      fromRoomingPerDayDataStore.featureKey,
      fromRoomingPerDayDataStore.reducer,
      { initialState: fromRoomingPerDayDataStore.initialState },
    ),
    EffectsModule.forFeature([RoomingPerDayDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class RoomingPerDayDataStoreModule {}
